import {Map, fromJS} from 'immutable'

import {
  SET_USER_SESSION_REFS,
  REMOVE_USER_SESSION_REF
} from '../action_types'

const sortRefsByStartTime = (refObject) => refObject.get('startTime')

const arrangeSessionRefsByUser = (userRefs) => {
  return userRefs
    .toList()
    .sortBy(sortRefsByStartTime)
}

const userSessionRefs = (refs) => {
  return fromJS(refs).withMutations((sessionRefs) => {
    sessionRefs.merge(sessionRefs.map(arrangeSessionRefsByUser))
  })
}

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_USER_SESSION_REFS:
      const sessionRefs = userSessionRefs(action.refs)
      return state.mergeDeep(sessionRefs)

    case REMOVE_USER_SESSION_REF:
      return state.delete(action.refKey)

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/session_refs.js
 **/